import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    formControlStock: ({
        margin: theme.spacing(1),
        minWidth: 120,
    }),
    button: ({
        display: 'block',
        marginTop: theme.spacing(2),
    }),
    formControl: ({
        margin: theme.spacing(1.5),
        minWidth: 120,
        width: 200,
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '42%'
        }
    }),
    ZD: ({
        margin: theme.spacing(1.5),
        minWidth: 120,
        width: 200,
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '90%'
        }
    }),
    paper: ({
        margin: '2%',
        padding: '1% 0 2%',
        border: '1px solid #ced0d0',
        // borderRadius: 10,
        backgroundColor: theme.palette.success.main
    }),
    setButton: ({
        [theme.breakpoints.between('sm', 'lg')]: {
            margin: theme.spacing(1),
            paddingTop: '5px'
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            paddingLeft: '10px',
            marginBlockStart: '10px',
            marginInlineEnd: '70px'
        }
    }),

}));

export default useStyles;